const prefix = 'help-osu-form-'
const htmlIdentifiers = {
    prefix,
    continue: prefix + '-continue',
    submit: prefix + '-submit',
    back: prefix + '-back',
    nextLabel: prefix + '-next-label',
}

module.exports = {
    htmlIdentifiers
}